import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-datacenter-solution',
  templateUrl: './datacenter-solution.component.html',
  styleUrls: ['./datacenter-solution.component.scss']
})
export class DatacenterSolutionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    document.getElementById("featured-services").scrollIntoView();
  }

}
